import {
	useMutation,
	UseMutationOptions,
	useQuery,
	UseQueryOptions,
} from "@tanstack/react-query";

import { CoreApi } from "../helpers/Http";

/**
 *  Get Clients 
 *
 * @param payload
 * @param options
 * @returns
 */

export const useGetClients = (options?: UseQueryOptions) => {
    const queryFn = async () => await CoreApi.get(`/clients`);
  
    return useQuery({
        queryKey: ['clients'],
        queryFn,
      });
};

/**
 *  Get Files 
 *
 * @param payload
 * @param options
 * @returns
 */

export const useGetFiles = (options?: UseQueryOptions) => {
  const queryFn = async () => await CoreApi.get(`/files`);

  return useQuery({
      queryKey: ['files'],
      queryFn,
    });
};

/**
 *  Get Experiments 
 *
 * @param payload
 * @param options
 * @returns
 */

export const useGetExperiments = (id: any, options?: UseQueryOptions) => {
  const queryFn = async () => await CoreApi.get(`clients/${id}/experiments`);

  return useQuery({
      queryKey: ['experiments', id],
      queryFn,
      enabled: false,
    });

    
}; 
/**
 *  Get Clients Configurations
 *
 * @param payload
 * @param options
 * @returns
 */

export const useGetClientsConfigurations = (options?: UseQueryOptions) => {
  const queryFn = async () => await CoreApi.get(`/clients/platforms`);

  return useQuery({
      queryKey: ['dataSource-clients'],
      queryFn,
    });
};

/**
 *  Get Client Files 
 *
 * @param payload
 * @param options
 * @returns
 */

export const useGetClientFiles = (id: any, options?: UseQueryOptions) => {
  const queryFn = async () => await CoreApi.get(`clients/${id}/files`);

  return useQuery({
      queryKey: ['files', id],
      queryFn,
      enabled: !!id,
    });    
}; 

/**
 *  Get Client Details 
 *
 * @param payload
 * @param options
 * @returns
 */

export const useGetClientDetails = (id: any, options?: UseQueryOptions) => {
  const queryFn = async () => await CoreApi.get(`clients/${id}/client-details`);

  return useQuery({
      queryKey: ['client-details', id],
      queryFn,
      enabled: !!id,
    });    
}; 


/**
 *  Get Client Experiments Files 
 *
 * @param payload
 * @param options
 * @returns
 */

export const useGetClientExperimentsFiles = (id: any, options?: UseQueryOptions) => {
  const queryFn = async () => await CoreApi.get(`clients/${id}/experiments/files`);

  return useQuery({
      queryKey: ['experiments', id],
      queryFn,
      enabled: !!id,
    });    
}; 





 